export { SERVICES, SERVICE_MAP, FEATURED_SERVICES, FEATURED_SERVICE_SLUGS, CORE_SERVICES, CORE_SERVICE_MAP } from "./services.mjs";

export const COMPANY = {
  name: "Peak Plumbing",
  tagline: "Where others stop at the base, we strive for the peak.",
  phone: "(586) 351-6271",
  phoneTel: "+15863516271",
  email: "info@peakplumbingmi.com",
  city: "Roseville, MI",
  region: "Macomb County, Michigan",
  address: "Roseville, Macomb County, MI",
  hours: "Emergency service available",
  yearsExperience: null,
  jobsCompleted: "Hundreds of homes served",
  rating: 4.9,
  reviewCount: 412,
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_drain-fix-utica/artifacts/e0mlfz5w_IMG_9880.png",
};

export const SERVICE_AREAS = [
  "Utica", "Sterling Heights", "Shelby Township", "Macomb Township",
  "Washington Township", "Clinton Township", "Rochester Hills", "Rochester",
  "Warren", "Troy", "Romeo", "Chesterfield",
];

export const TESTIMONIALS = [
  {
    name: "Sarah M.",
    city: "Sterling Heights",
    rating: 5,
    quote:
      "Main sewer line backed up on a Sunday night. Peak was at my house in 40 minutes, fixed it for a fair price, and even cleaned up after. Unreal service.",
  },
  {
    name: "Mike D.",
    city: "Shelby Township",
    rating: 5,
    quote:
      "Honest guys. I got two other quotes that were nearly double. They camera-scoped the line, showed me exactly what was wrong, and got it done same day.",
  },
  {
    name: "Karen L.",
    city: "Utica",
    rating: 5,
    quote:
      "Water heater died on a Saturday morning. New one installed by 2pm. Polite, clean, and they explained everything. I'll never call anyone else.",
  },
  {
    name: "Jason P.",
    city: "Macomb Twp.",
    rating: 5,
    quote:
      "Hydro jetted a years-old root problem in our main line. Drains have never worked better. Worth every penny — and they were the cheapest quote I got.",
  },
];

export const FAQS = [
  {
    q: "What are your hours?",
    a: "Our office team answers calls during business hours and dispatches technicians for emergency plumbing issues promptly. Leave a message any time and we'll return your call first thing.",
  },
  {
    q: "Are you insured?",
    a: "Absolutely. Peak Plumbing is fully bonded and carries complete liability insurance so every job is covered. We provide proof on request.",
  },
  {
    q: "Do you give free estimates?",
    a: "Yes. We offer free, no-obligation estimates on most jobs over the phone or on-site. We'll never start work without your written approval.",
  },
  {
    q: "What areas do you serve?",
    a: "We serve Roseville and the surrounding Macomb County communities including Sterling Heights, Shelby Twp., Macomb Twp., Washington Twp., Clinton Twp., Rochester Hills, Warren, Troy and more.",
  },
  {
    q: "Do you offer financing?",
    a: "Yes. We partner with leading financing providers to offer 0% APR plans for qualified customers on larger projects like sewer line replacement and water heater installs.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept all major credit cards, debit, check, cash, and offer financing options. Payment is due upon job completion unless other arrangements are made in advance.",
  },
];
